import React from 'react';
export function Footer() {
  return <footer className="bg-cream-100 py-10 px-5 sm:px-6 border-t border-cream-300" data-id="element-83" data-mp="32wd2qgad7ltj">
      <div className="max-w-3xl mx-auto text-center" data-id="element-84" data-mp="3gg0yw2enzvx4">
        <div className="inline-flex items-center gap-2" data-id="element-85" data-mp="32o4bucrusc7l">
          <span className="text-xl" aria-hidden="true" data-id="element-86" data-mp="32pfci3q053uh">🌿</span>
          <span className="text-rose-600 font-bold tracking-widest uppercase" data-id="element-87" data-mp="36oo9rik93jus">
            PUNTO DIGITAL™
          </span>
        </div>
        <p className="text-sm text-ink-muted leading-snug mt-2 max-w-xl mx-auto" data-id="element-88" data-mp="3uftmvpyt3y1e">
          Herramientas prácticas para comprender la perimenopausia y la
          menopausia, organizar tus principales cambios y saber por dónde
          empezar.
        </p>
        <p className="font-serif text-[15px] text-rose-700 italic leading-snug mt-3 max-w-xl mx-auto" data-id="element-89" data-mp="3qcnkiteter07">
          “Porque atravesar esta etapa no debería significar buscar respuestas
          diferentes todos los días sin saber qué hacer con ellas.”
        </p>

        <div className="flex flex-wrap justify-center items-center gap-x-3 gap-y-1 text-sm text-ink-muted mt-4" data-id="element-90" data-mp="2evxaez79tf1b">
          <a href="mailto:supportpuntodigital@gmail.com" className="hover:text-rose-600 transition-colors" data-id="element-91" data-mp="3gapcfgy9ogex">
            📧 supportpuntodigital@gmail.com
          </a>
          <span className="text-rose-300" aria-hidden="true" data-id="element-92" data-mp="3v916dfu99b2e">•</span>
          <a href="https://www.puntodigital.store" className="hover:text-rose-600 transition-colors" data-id="element-93" data-mp="3q7lqs3aujwre">
            🌐 www.puntodigital.store
          </a>
        </div>

        <hr className="w-[82%] mx-auto my-5 border-t border-rose-200" data-id="element-94" data-mp="34723g4s9vvk" />

        <p className="text-xs text-ink-soft" data-id="element-95" data-mp="3232vbhtxl1m">
          © Punto Digital™ 2026 — Todos los derechos reservados.
        </p>
        <p className="text-[11px] text-ink-soft mt-1" data-id="element-96" data-mp="cu0h6r44wt4k">
          Prohibida la reproducción y redistribución sin autorización expresa.
        </p>

        <p className="text-[11px] text-ink-muted leading-relaxed mt-5 max-w-lg mx-auto" data-id="element-97" data-mp="qu1fbyt0lmgc">
          <span className="font-bold" data-id="element-98" data-mp="mt7r14bnu5mx">AVISO:</span> Este material tiene fines
          educativos e informativos y no sustituye la evaluación, diagnóstico ni
          tratamiento de un profesional de salud.
        </p>
      </div>
    </footer>;
}